import {fixLottieSwiper, loadElementLottie} from "../animations/lottie";
import {openBook, closeBook, toggleBook} from "../book";
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

const lazy = new LazyLoad();

export function createSourceSlider(id) {

    let container = $("#" + id);

    let opt = {
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            500: {
                slidesPerView: 1.5
            },
            700: {
                slidesPerView: 2.3,
            },
            800: {
                slidesPerView: 3
            },
            1024: {
                slidesPerView: 'auto'
            }
        },
        speed: 700,
        simulateTouch: true,
        loopAdditionalSlides: 6,
        loop: true,
        pagination: {
            el: '#'+id+' .swiper-pagination-mobile',
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 1,
            renderBullet: function (index, className) {
                return '<span class="' + className + '" ><svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><circle stroke="white" stroke-width="3" cx="4" cy="4" r="4" fill="white"></circle></svg></span>';
            },
        },

        navigation: {
            nextEl: '#'+id+' .js-slider-next',
            prevEl: '#'+id+' .js-slider-prev',
        },
        on: {
            init: function (e) {
                lazy.update()
                toggleBook()
                loadElementLottie($('.js-load-lottie'))
                loadElementLottie($('.js-load-lottie-cart'))
                fixLottieSwiper()
                let currentSlide = container.find(`.swiper-slide-active[data-swiper-slide-index='${e.realIndex}']`)
                startProgressLine(e,currentSlide,id)
            },
            slideChange: function (e) {
                lazy.update()
                let swiperContainer = $(this.el);
                let currentSlide = swiperContainer.find(`[data-swiper-slide-index='${e.realIndex}']`)
                startProgressLine(e,currentSlide,id)
            },
            slideChangeTransitionEnd: function (e) {

                if(e.autoplay.running) {
                    let swiperContainer = $(this.el);
                    let currentSlide = swiperContainer.find(`[data-swiper-slide-index='${e.realIndex}']`)
                    let t = currentSlide.find(".js-close-details");
                    closeBook(t)
                } else {
                    e.autoplay.stop()
                }

            },
            slideChangeTransitionStart: function (e) {
            },
            reachBeginning: function (e) {
                let currentSlide = container.find(`.swiper-slide-active[data-swiper-slide-index='${e.realIndex}']`)
                startProgressLine(e,currentSlide,id)
            }
        },
    };

    let source_slider = new Swiper("#" + id + " .swiper-container", opt);

    $("#"+id+" .link-with-icon").on("click tap", function() {
        console.log("link-with-icon")
        window.location.href = $(this).attr("href");
        return true;
    });

    $("#"+id+" .js-open-details").on("click tap", function() {
        let $this = $(this);
        console.log(source_slider)
        let swiperContainer = $this.closest('.js-sources-slider')
        let swiperInstance = swiperContainer[0].swiper
        let currentSlide = swiperContainer.find(`.swiper-slide-active[data-swiper-slide-index='${swiperInstance.realIndex}']`)
        pauseProgressLine(swiperInstance,currentSlide,id)
        openBook($this)
    });

    $("#"+id+" .js-close-details").on("click tap", function() {
        let $this = $(this);
        let swiperContainer = $this.closest('.js-sources-slider')
        let swiperInstance = swiperContainer[0].swiper
        let currentSlide = swiperContainer.find(`.swiper-slide-active[data-swiper-slide-index='${swiperInstance.realIndex}']`)
        swiperInstance.autoplay.start();
        startProgressLine(swiperInstance,currentSlide,id)
        closeBook($this)
    });

    return source_slider;

}

// Function to pause the progress line animation
function pauseProgressLine(swiper,currentSlide,id) {

    let line = currentSlide.find('.js-progress-line')

    console.log(swiper)

    line.addClass("stoped")
    swiper.autoplay.stop();
    line.stop(true)

    currentSlide.siblings().find('.js-progress-line').stop().animate(
        {width: 0
        }, 0, 'linear');

    if(swiper.clickedIndex !== swiper.realIndex) {
        swiper.slideTo(swiper.clickedIndex)
    } else {
        let lineWidth = parseInt(line.css('width'));
        let parentWidth = parseInt(line.parent().css('width'));
        let width = lineWidth / parentWidth
        let newDelay = 8000 - (8000 * width)
        currentSlide.attr('data-swiper-autoplay', newDelay)
        let t = currentSlide.find(".js-close-details");
        closeBook(t)

    }

}

// Function to restart the progress line animation
function startProgressLine(swiper,currentSlide,id) {
    let line = currentSlide.find('.js-progress-line')
    line.removeClass("stoped")
    let block = $("#"+id+ " .block-slider");

    let newDelay = parseInt(currentSlide.attr('data-swiper-autoplay'))

    currentSlide.siblings().find('.js-progress-line').stop().animate(
        {width: 0
        }, 0, 'linear');

    if(block.hasClass("show")) {

        line.animate({
            width: "100%"
        }, newDelay, 'linear', function() {

            if(!line.hasClass("stoped")) {
                swiper.slideNext();
            }

        });

    }

}
